import React, { useEffect, useState } from 'react'
import UiIntegrater from '../littleUIComponent/UiIntegrater';
import LineChart4in1 from './LineChartFourInOne';
import SleepPieChart from './SleepPieChart';
import SETable from './SETable';
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../../actions/ApiGo';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_RESPONSE } from '../../../../stores/reducer_add';

const default_sleep_data = [{
    NIB_max_time: "None",
    NIB_num: "None",
    SE: "None",
    average_NIB_max_time: "None",
    average_NIB_num: "None",
    average_SE: "None",
    average_total_NIB_time: "None",
    average_total_sleep_latency: "None",
    average_total_sleep_time: "None",
    average_total_time: "None",
    average_turn_over_num: "None",
    bed_id: "None",
    created_at: "None",
    end_time: "None",
    id: "None",
    resident_id: "None",
    start_time: "None",
    total_NIB_time: "None",
    total_sleep_latency: "None",
    total_sleep_time: "None",
    total_time: "None",
    turn_over_num: "None",
    updated_at: "None"
}]
const default_line_data = {
    "primary":[],
    "secondary":[]
}

// 主元件
const HISSEChart =(props)=>{
    const dispatch = useDispatch()
    const {t} = useTranslation()
    let resident = props.data || {id:19}
    const [sleepData, setSleepData] = useState(default_sleep_data);
    const [SEData, setSEData] = useState(default_line_data);
    const [NIBData, setNIBData] = useState(default_line_data);
    const [NIBtimes, setNIBtimes] = useState(default_line_data);
    const [NIBMax, setNIBMax] = useState(default_line_data);
    const [totalSleepTime, setTotalSleepTime] = useState(default_line_data);
    const [latency, setLatency] = useState(default_line_data);
    const [turnCount, setTurnCount] = useState(default_line_data);
    const [startSleepTime, setStartSleepTime] = useState(default_line_data);
    const [endSleepTime, setEndSleepTime] = useState(default_line_data);
    const store_timestamp = useSelector(state=>state.store_historyData.timestamp)
    const [dataToday, setdataToday] = useState({});
    const [chartSwitch, setChartSwitch] = useState(0);
    useEffect(() => {
        let _d = new Date(store_timestamp)
        let _date_now = new LogTime(_d).getDate()
        let _d7 = new Date(store_timestamp - 86400000*14)
        let _d1 = new Date(store_timestamp - 86400000*1)
        let _date_7daysago = new LogTime(_d7).getDate()
        let _date_1daysago = new LogTime(_d1).getDate()

        get_sleep_data(_date_7daysago, _date_now).then(res=>{
            // pie chart
            setSleepData(res)
            // SE line chart
            let [_SE_arr, _avg_SE_arr] = handleSleepData(res, "SE", "average_SE")
            setSEData({ "primary":_SE_arr,"secondary":_avg_SE_arr })
            // total nib chart
            let [_NIBT_arr, _avg_NIBT_arr] = handleSleepData(res, "total_NIB_time", "average_total_NIB_time")
            setNIBData({ "primary":_NIBT_arr, "secondary":_avg_NIBT_arr })
            // total nib times
            let [_NIBts_arr, _avg_NIBts_arr] = handleSleepData(res, "NIB_num", "average_NIB_num")
            setNIBtimes({ "primary":_NIBts_arr, "secondary":_avg_NIBts_arr })
            // max nib
            let [_NIBM_arr, _avg_NIBM_arr] = handleSleepData(res, "NIB_NIB_max_timeum", "average_NIB_max_time")
            setNIBMax({ "primary":_NIBM_arr, "secondary":_avg_NIBM_arr })
            // sleepTime
            let [_sleep_time_arr, _avg_sleep_time_arr] = handleSleepData(res, "total_sleep_time", "average_total_sleep_time")
            setTotalSleepTime({ "primary":_sleep_time_arr, "secondary":_avg_sleep_time_arr })
            // latency
            let [_Latency_arr, _avg_Latency_arr] = handleSleepData(res, "total_sleep_latency", "average_total_sleep_latency")
            setLatency({ "primary":_Latency_arr, "secondary":_avg_Latency_arr })
            // start time
            let _start_arr = handleSleepData_withTime(res, "start_time")
            setStartSleepTime({ "primary":_start_arr, "secondary":[] })
            // end time
            let _end_arr = handleSleepData_withTime(res, "end_time")
            setEndSleepTime({ "primary":_end_arr, "secondary":[] })
            // turn count
            let [_turnCount_arr, _avg_turnCount_arr] = handleSleepData(res, "turn_over_num", "average_turn_over_num")
            setTurnCount({ "primary":_turnCount_arr, "secondary":_avg_turnCount_arr })

        })
        .catch(()=>{
            setSleepData(default_sleep_data)
            setSEData(default_line_data )
            setNIBData(default_line_data)
            setNIBtimes(default_line_data)
            setNIBMax(default_line_data)
        })
        get_sleep_data(_date_1daysago, _date_now)
        .then(res=>{setdataToday(res[0])})
        .catch(()=>{setdataToday(default_sleep_data)})

        function get_sleep_data(_date_from, _date_to){
            return new Promise((resolve, reject)=>{
                ApiGo.getSleepQuality_ByResident(resident.id, _date_from, _date_to)
                .then(res=>{
                    let _sortRes = res.sleep_qualities
                    _sortRes.sort((a,b)=>{
                        return new Date(a.start_time) - new Date(b.start_time)
                    })
                    resolve(_sortRes)
                })
                .catch(err=>{
                    dispatch(ADD_RESPONSE({status:err.status, statusText:err.statusText, type:"hisRec_no_data"}))
                    reject(err)
                })
            })
        }

        function handleSleepData(_res, _param, _avg_param){
            let _arr = _res.map(_SE=>{
                // const _d = new Date(_SE.created_at)
                const _d = new Date(_SE.start_time)
                let _num = Math.abs(parseFloat(_SE[_param])).toFixed(2)
                // + 28800000 用意是從 UTC +0 轉為 GMT +8 (8hr = 28800000ms)
                return [_d.getTime()+28800000, Math.abs(_num)]
            })
            let _avg_arr = _res.map(_SE=>{
                // const _d = new Date(_SE.created_at)
                const _d = new Date(_SE.start_time)
                if(_SE[_avg_param]===null){return [_d.getTime()+28800000, _SE[_avg_param]]}
                else{return [_d.getTime()+28800000, Math.abs(parseFloat(_SE[_avg_param]).toFixed(2))]}
            })
            return [_arr, _avg_arr]
        }
        function handleSleepData_withTime(_res, _param){
            let _arr = _res.map(_SE=>{
                // const _d = new Date(_SE.created_at)
                const _d = new Date(_SE.start_time)
                let _time = new Date(_SE[_param])
                let _t = _time.getHours()*3600 + _time.getMinutes()*60 + _time.getSeconds()
                return [_d.getTime()+28800000, _t]
            })
            return _arr
        }

    }, [store_timestamp, resident.id]);
    return(<>
        <UiIntegrater
            OnOff_switch={[true, false, false, true, true]}
            date={new Date()}
            name={(props.data!==undefined)?props.data.last_name:""}
            bed={(props.data!==undefined)?props.data.first_name:""}
            />
        {/* <TestSE date={store_timestamp}/> */}
        <div className="fx-d-c w-100 outer-chart-frame hisChart">
            <div className='w-80 h-100 font-l fx-d-c addSwitch_SE inputBox_SE'>
                <div className='fx-d-r w-100 h-100 fx-ccc SwitchTag'>
                    <div className={`fx-ccc outer_active l ${chartSwitch===0? 'dismiss':''}`}
                        onClick={()=>{setChartSwitch(0)}}>
                        <div className={`fx-ccc l ${chartSwitch===0? 'inner_active':''}`}>{t("HISTORY_RECORD.SLEEP_SUMMARY")}</div>
                    </div>
                    <div className={`fx-ccc outer_active in ${chartSwitch===1? '':'dismiss'}`}
                        onClick={()=>{setChartSwitch(1)}}>
                        <div className={`fx-ccc in ${chartSwitch===1? 'inner_active':''}`}>{t("HISTORY_RECORD.SLEEP_TIME")}</div>
                    </div>
                    <div className={`fx-ccc outer_active in add ${chartSwitch===2? '':'dismiss'}`}
                        onClick={()=>{setChartSwitch(2)}}>
                        <div className={`fx-ccc in ${chartSwitch===2? 'inner_active':''}`}>{t("HISTORY_RECORD.SLEEP_NO_IN_BED")}</div>
                    </div>
                    <div className={`fx-ccc outer_active r add ${chartSwitch===3? '':'dismiss'}`}
                        onClick={()=>{setChartSwitch(3)}}>
                        <div className={`fx-ccc r ${chartSwitch===3? 'inner_active':''}`}>{t("HISTORY_RECORD.SLEEP_WAKE_UP")}</div>
                    </div>
                </div>
            </div>
            <div className='fx-d-r w-100 border_bgC _SE_top'>
            {/* <div className='fx-d-c h-100 min-w300'> */}
                <div className=' h-100 w-100'>
                    <LineChart4in1
                        chartSwitch = {chartSwitch}
                        timeSelc={store_timestamp}
                        SEdata={SEData}
                        NIBdata={NIBData}
                        NIBtimes={NIBtimes}
                        NIBMax={NIBMax}
                        turnCount={turnCount}
                        startSleepTime={startSleepTime}
                        endSleepTime={endSleepTime}
                        latency={latency}
                        totalSleepTime={totalSleepTime}
                        chartName={t("HISTORY_RECORD.SECHART")}
                    />
                </div>
            </div>
        </div>
    </>);
}
export default HISSEChart;